import { FC } from 'react'

// eslint-disable-next-line import/no-extraneous-dependencies
import { Button } from 'baby-design'

import { showSpoilerAlertModal } from '../SpoilerAlertModal'
import styles from './SurpriseProduct.styles.scss'

const Image: FC = () => (
  <div className={styles.SurpriseProduct__ImageContainer}>
    <img
      alt="gift box"
      className={styles.SurpriseProduct__ProductImage}
      src="https://images.babylist.com/image/upload/v1736474692/registry-icons/gift-box.svg"
    />
  </div>
)
const RevealSurpriseButton: FC<{
  name: string
  revealSurprises: () => void
}> = ({ name, revealSurprises }) => (
  <div>
    <Button
      size="md"
      variant="tertiary"
      onClick={() => showSpoilerAlertModal({ name, revealSurprises })}
    >
      Reveal gift
    </Button>
  </div>
)

const SurpriseProduct: FC<{ name: string; revealSurprises: () => void }> = ({
  name,
  revealSurprises,
}) => (
  <div className={styles.SurpriseProduct}>
    <Image />
    <RevealSurpriseButton name={name} revealSurprises={revealSurprises} />
  </div>
)

export default SurpriseProduct
